export default __webpack_public_path__ + "dd6d3a20b82a4b5e474e3a8dab39df67.svg";